import "../icon-svg.less";

const IconComment = ({ className = "" }: { className?: string }) => (
  <svg
    className={`icon-svg icon-comment ${className}`}
    viewBox="0 0 22 22"
    version="1.1"
    fill="none"
  >
    <g id="Group 259">
      <g id="icon/&#232;&#175;&#132;&#232;&#174;&#186;" clipPath="url(#clip0_257_3783)">
        <g id="Group 258">
          <path
            id="Vector"
            d="M20.5999 4.26872C20.5999 3.43157 19.9213 2.75293 19.0841 2.75293H2.91569C2.07854 2.75293 1.3999 3.43157 1.3999 4.26872V15.6369C1.3999 16.474 2.07854 17.1527 2.91569 17.1527H5.7199V19.5526L10.5199 17.1527H19.0841C19.9213 17.1527 20.5999 16.474 20.5999 15.6369V4.26872Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M6.19971 9.23242V10.6724"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M10.9998 9.23242V10.6724"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M15.7998 9.23242V10.6724"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_257_3783">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconComment;
